// @flow
import React, {useContext, useEffect, useState} from "react";
import Header from "./Header";
import BackButton from "../GUI_COMMON/COMPONENTS/BackButton";
import {Redirect} from "react-router-dom";
import {StoreContext} from "../GUI_COMMON/SUPPORT/store";
import ErrorPopup from "../GUI_COMMON/COMPONENTS/ErrorPopup";
//import {gotLocations} from "../ACTIONS/clientActions";
import ArchiverClientApi from "../API/archiverClientApi";
import Popup from "../GUI_COMMON/COMPONENTS/Popup";
import {useHistory} from "react-router";
import LIUtils from "../GUI_COMMON/SUPPORT/LIUtils";
import LoadingSpinner from "../GUI_COMMON/COMPONENTS/LoadingSpinner";
import ArchiverGuiUtils from "../SUPPORT/ArchiverGuiUtils";
import type {BTOBox, BTOBoxAndMagsItem} from "./BTOAddUpdatePage";

export const BTO_GHOSTBOX_BARCODE = "UNREGISTERED BOX"; // *** this needs to match the magic string in the archiver

/**
 * returns true if the given box is a ghost box
 * @param box
 * @returns {boolean}
 */
export function boxIsGhostBox(box:BTOBox) {
    return box.barcode === BTO_GHOSTBOX_BARCODE;
}

const BTOPickSheetPage = () => {

    const SORT_ORDER_BOX_LOCATION: Number = 0;
    const SORT_ORDER_ORDER_NUMBER: Number = 1;

    const [globalState] = useContext(StoreContext);
    const [isLoading, setIsLoading] = useState(false);
    //const [isMarkingAsComplete, setIsMarkingAsComplete] = useState(false); 
    const [redirectTo, setRedirectTo] = useState();
    const [checkedItems, setCheckedItems] = useState({});
    const [boxesByLocation: BTOBoxAndMagsItem[], setBoxesByLocation] = useState([]);
    const [boxesByOrderId:  BTOBoxAndMagsItem[], setBoxesByOrderId] = useState([]);
    const [rawBoxesAndMagsList: BTOBoxAndMagsItem[], setRawBoxesAndMagsList] = useState( []);
    const [gOrders, setGOrders] = useState([]);
    const [aBoxIsSelected, setABoxIsSelected] = useState(false);
    const [pickSheetDate] = useState(new Date());
    const [orderBy, setOrderBy] = useState(SORT_ORDER_BOX_LOCATION);

    const history = useHistory();
    
    // useEffect( () => { // load locations if they don't exist
    //     if(!globalState.locations || globalState.locations.length===0) {
    //         // get the enabled and disabled locations (we filter based on readonly)
    //         ArchiverClientApi.getLocations(false).then( locations => {
    //             dispatch(gotLocations(locations));      // locations and their departments
    //         })
    //         .catch(responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError));
    //     }
    // },[globalState.locations]);  // eslint-disable-line react-hooks/exhaustive-deps
    
    useEffect(() => {
        if (history.location.search) { // get the orders list 
            let orderStr = history.location.search;
            let orderList = [];
            if (orderStr && orderStr.length > 0) {
                orderStr = decodeURI(orderStr);
                if (orderStr.startsWith('?')) orderStr = orderStr.slice(1); // kill '?'
                if (orderStr.endsWith(',')) orderStr = orderStr.slice(0, -1);
                const re = /[?,]/;
                orderList = orderStr.split(re);
                orderList = orderList.map(item => Number(item));  // we want id numbers, not strings
            }
            setIsLoading(true);
            ArchiverClientApi.getBoxPickSheet(orderList)
            .then(({orders, boxesAndChildMags}) => {
                setGOrders(orders);
                setRawBoxesAndMagsList(boxesAndChildMags);
            })
            .catch(responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
            .finally(() => setIsLoading(false));
        }
    }, [history.location.search]);  // eslint-disable-line react-hooks/exhaustive-deps
    
    useEffect(() => {
        if(rawBoxesAndMagsList) {

            if (orderBy === SORT_ORDER_BOX_LOCATION) {
                const boxesByLocation = sortBoxesByLocation(rawBoxesAndMagsList); // copy 
                setBoxesByLocation(boxesByLocation);
            } else if (orderBy === SORT_ORDER_ORDER_NUMBER) {
                const boxesByOrderId = sortBoxesByOrderId(rawBoxesAndMagsList); // copy
                setBoxesByOrderId(boxesByOrderId);
            }
            checkForPickSheetComplete(rawBoxesAndMagsList);
        }
    }, [rawBoxesAndMagsList, orderBy]); // eslint-disable-line react-hooks/exhaustive-deps
    
    useEffect(() => {
        setABoxIsSelected(haveCheckedNonDisabledBoxes(checkedItems));
    }, [checkedItems]);

    //#region SORTERS

    function sortBoxesByOrderId(boxesWithMags:BTOBoxAndMagsItem[]) {
        const copyOf = boxesWithMags?.slice()??[];
        copyOf.sort((a, b) => {
            if (a.box.parentOrderId < b.box.parentOrderId) return -1;
            if (a.box.parentOrderId > b.box.parentOrderId) return 1;
            return 0;
        });

        return copyOf;
    }
    
    function sortBoxesByLocation(boxesWithMags:BTOBoxAndMagsItem[]) {
        const copyOf = boxesWithMags?.slice()??[];
        copyOf.sort((a, b) => {
            if (a.box.storageLocationId < b.box.storageLocationId) return -1;
            if (a.box.storageLocationId > b.box.storageLocationId) return 1;
            return 0;
        });
        return copyOf;
    }

    //#endregion SORTERS

    //#region HANDLERS

    function handleCBChanged(e, item) {
        const isChecked = e.target.checked;
        checkOrUncheckBox(item, isChecked)
    }

    function checkOrUncheckBox(item, shouldCheck: boolean) {
        const curCheckedItems = {...checkedItems};
        if (shouldCheck) {
            curCheckedItems[item.id] = item;
        } else {
            delete (curCheckedItems[item.id]);
        }
        setCheckedItems(curCheckedItems); // update

        setABoxIsSelected(haveCheckedNonDisabledBoxes(curCheckedItems));
    }

    function handleSelectAllCBChanged(e) {
        const isChecked = e.target.checked;
        let curCheckedItems = {...checkedItems};

        if (isChecked) { // add all to the checked list
            if(rawBoxesAndMagsList && rawBoxesAndMagsList.length > 0) {
                rawBoxesAndMagsList.forEach(boxWithMags => {
                    if(!boxHasBeenPicked(boxWithMags.box) && !boxIsDisabled(boxWithMags.box)) {
                        curCheckedItems[boxWithMags.box.id] = boxWithMags.box;
                    }
                });
            }
        } else { // remove all from checked list
            curCheckedItems = {};
        }
        setCheckedItems(curCheckedItems); // update

        setABoxIsSelected(haveCheckedNonDisabledBoxes(curCheckedItems));
    }
    
    function boxIsDisabled(box:BTOBox) {
        
        if(box.datePickCompleted !== null || box.id === 0) {  // ghost box or already picked
            return true;
        }
        if(box.pendingOnOrderId && box.pendingOnOrderId!==box.parentOrderId) { // pending on another order
            return true;
        }
        return false;
    }

    function handlePrintPage() {
        window.print();
    }

    function handlePickBoxes() {
        const boxIdsWithOrderIds = Object.keys(checkedItems).map((key) => {
            const theBox = checkedItems[key];
            return {boxId: Number(key), orderId: Number(theBox.parentOrderId)};  // returning an object per item
        });

        Popup.showConfirm("Remove Boxes?", `<p>Are you sure you want to remove the ${boxIdsWithOrderIds.length} selected boxes from their current location?</p>` + 
            "<p>* The system will initiate a relocation process shortly that moves all child magazines and their samples to the new location.</p>",
            "Yes, Pick These!", null, () => doKickOffBoxRelocationAtServer(boxIdsWithOrderIds),null,null,"No, Cancel");
    }

    //#endregion HANDLERS

    //#region OUTPUT_FUNCTIONS

    function dumpOrderNumberAndDest(orderNumber, sendTo) {
        return <div className="text-right">
                <span className="li-font-small d-block ml-2">
                    <i>ORDER:</i> <strong>{LIUtils.prettyOrderNumber(orderNumber)}</strong><br/>
                <span className="badge li-bg-light ml-2">{sendTo ?? "-"}</span>
                </span>
        </div>;
    }

    function dumpBoxAsIn(boxWithMags: BTOBoxAndMagsItem, key, thisOrderNumber:number, showOrder: boolean = true, showLocation: boolean = true) {
        const boxItem = boxWithMags.box;
        return (<tr key={key}>
            <td>
                <input type="checkbox" className="m-2 large align-self-center li-sample-cb"
                       name={"retrieval-cb-" + boxItem.id}
                       disabled={ArchiverGuiUtils._isBoxOriginallyFromThisOrderButPendingOnAnotherOrder(boxItem, thisOrderNumber)}
                       aria-label="Checkbox" onChange={(e) => handleCBChanged(e, boxItem)}
                       checked={checkedItems[boxItem.id] ?? false}/>
            </td>
            <td><strong>
                {buildPickSheetBoxDetailsStr(boxItem.barcode, boxWithMags.childMags.length)}</strong>
                {ArchiverGuiUtils.ShowBoxIsPendingPickedOrShipped(boxItem, null,null,true, thisOrderNumber)}
            </td>
            <td/>
            <td className="text-right">
                {showLocation && <span className="">
                            <i className="fa fa-caret-right mx-2 li-fg-primary"/>
                    {buildBoxLocationStringForItemRow(boxItem.storageLocationId)}
                        </span>}
                {showOrder && dumpOrderNumberAndDest(
                    boxItem.parentOrderId,"")}
            </td>
        </tr>);
    }

    function dumpBoxAsOut(boxWithMags: BTOBoxAndMagsItem, key, thisOrderNumber:number, showOrder: boolean = true, showLocation: boolean = true) {
        const boxItem = boxWithMags.box; 
        return (<tr key={key}>
                <td>
                    <input type="checkbox" className="m-2 large align-self-center li-sample-cb"
                           name={"retrieval-cb-" + key}
                           aria-label="Checkbox" disabled={true} checked={boxItem.datePickCompleted !== null}/>
                </td>
                <td>
                    <span style={{textDecoration: "line-through"}}>
                        {buildPickSheetBoxDetailsStr(boxItem.barcode, boxWithMags.childMags.length)}
                    </span>
                    {ArchiverGuiUtils.ShowBoxIsPendingPickedOrShipped(boxItem, null, null,false, thisOrderNumber)}
                </td>
                <td/>
                <td className="text-right">
                    {showLocation && <span className="">
                        <i className="fa fa-caret-right mx-2 li-fg-primary"/>
                        {buildBoxLocationStringForItemRow(boxItem.storageLocationId)}
                    </span>}
                    {showOrder && dumpOrderNumberAndDest(
                        boxItem.parentOrderId,"")}
                </td>
            </tr>);
    }
    
    function dumpBoxAsGhostBox(boxWithMags: BTOBoxAndMagsItem, key, thisOrderNumber:number, showOrder: boolean = true) {
        const boxItem = boxWithMags.box;
        return (<tr key={key}>
                <td>
                    <input type="checkbox" className="m-2 large align-self-center li-sample-cb"
                           name={"retrieval-cb-" + boxItem.id} onChange={(e) => handleCBChanged(e, boxItem)}
                           aria-label="Checkbox" disabled={true} checked={checkedItems[boxItem.id] ?? false}/>
                </td>
                <td colSpan="3">
                    {BTO_GHOSTBOX_BARCODE} - <i className="li-fg-danger font-weight-bold">these magazines are not part of any box and will need to be removed from this box order.</i>
                    {buildPickSheetBoxChildMagDetails(boxWithMags, thisOrderNumber, showOrder)}
                </td>
            </tr>); 
    }

    function buildPickSheetBoxDetailsStr(barcode: string, numChildMags:number=null) {
        if (numChildMags !== null && numChildMags > 0) {
            return (barcode + " (" + numChildMags + " mag"+ (numChildMags > 1 ? "azines" : "azine") + ")");
        }
        if (barcode && barcode !== "") {
            return barcode;
        }
        return ("unknown");
    }
    
    function buildPickSheetBoxChildMagDetails(boxItem: BTOBoxAndMagsItem, thisOrderNumber:number, showOrder: boolean = true) {
        if(boxItem.childMags && boxItem.childMags.length>0) {
            const magList = boxItem.childMags.map(mag => {
                const pickedBadge = ArchiverGuiUtils.ShowMagIsPicked(mag, null);
                const storageInfo = ArchiverGuiUtils.GetShortLocationStringGivenMagStorageLocation(mag.storageLocation);
                return <li key={mag.id+"-"+boxItem.box.parentOrderId}>Magazine: {mag.barcode} {pickedBadge}
                    <i className="fa fa-caret-right ml-5 mx-2 li-fg-primary"/>
                    <span className="li-fg-dark li-font-small text-right">{storageInfo}</span>
                    <div className="d-inline-block ml-5">{showOrder && dumpOrderNumberAndDest(thisOrderNumber,"")}</div>
                </li>;
            });
            return <ul>{magList}</ul>;
        }
    }
    
    function buildBoxCountsElement(boxesForOrderTypes: [], magTypes: []) {
        if (boxesForOrderTypes.length === 0) {
            return <div className="text-right li-font-small">No boxes for this order</div>;
        }
        const totalBoxCount = boxesForOrderTypes.reduce((prevVal, boxCountForType) => { return prevVal + boxCountForType; }, 0);
        return <div className="text-right li-font-small">
            <i className="fa fa-box li-fg-success mr-2"/>
            <span className="font-weight-normal">Boxes: </span>
            <span className="li-fg-dark li-font-medium">{totalBoxCount}</span>
        </div>;
    }

    function buildBoxLocationStringForHeader(storageLocationId: number) {
        let locStr = ArchiverGuiUtils.GetLocationBasedOnDeptId(storageLocationId, globalState.locations);
        return <td colSpan="4">
            <h3 style={{borderTop: "4px solid black"}}>
                <i className="fa fa-map-marked-alt li-fg-success mr-2"/>
                <span className="font-weight-normal">Stored at: </span>
                <span className="li-fg-dark li-font-medium">{locStr}</span>
            </h3>
        </td>;
    }

    function buildBoxLocationStringForItemRow(storageLocationId: number) {
        let locStr = ArchiverGuiUtils.GetLocationBasedOnDeptId(storageLocationId, globalState.locations);
        return <span className="li-fg-dark li-font-small text-right">{locStr}</span>;
    }

    function buildOrderHeaderString(orderNumber: number, boxesForOrderTypes: [] = []) {
        let orderStr = LIUtils.prettyOrderNumber(orderNumber);
        let requestedBy = "-"
        if (orderNumber === null || orderNumber === "-") {
            orderStr = "-";
        } else { // get out requested by
            requestedBy = getOrderRequestedBy(orderNumber, gOrders);
        }
        const countDetails = buildBoxCountsElement(boxesForOrderTypes, globalState.magTypes);

        return (<td colSpan="4">
                <h3 className="d-flex justify-content-between">
                    <div>
                        <i className="fa fa-file-alt li-fg-success mr-2"/>
                        <span className="font-weight-normal">Order #: </span>{orderStr}
                        <div className="li-font-small text-right">Requested By: {requestedBy}</div>
                    </div>
                    <div className="d-inline-block li-font-small">{countDetails}</div>
                    {/*{dumpDestinationHeaderString(destination)}*/}
                </h3>

            </td>);
    }
    
    function showBoxesOrderedByLocationAndBox() {

        if (!isOrderingByLocation()) { // don't show any of this.
            return;
        }

        if (!boxesByLocation || boxesByLocation.length === 0) {
            return <tr>
                <td colSpan="4">
                    <i className="fa fa-exclamation-circle li-fg-danger mr-2"/>No boxes found to pick.
                </td>
            </tr>;
        }

        const retVal = [];
        let curBoxBarcode:string= undefined;
        let curBoxLocation:number = undefined;
        let parentKey = undefined;
        boxesByLocation.forEach((boxWithMag: BTOBoxAndMagsItem, index) => {
            if (curBoxLocation !== boxWithMag.box.storageLocationId) { // dump out the location HEADER
                parentKey = "LOC-" +index +"-"+ curBoxLocation;
                curBoxLocation = boxWithMag.box.storageLocationId;
                retVal.push(<tr className="mt-3  border-bottom" key={parentKey}>
                    {buildBoxLocationStringForHeader(curBoxLocation)}</tr>);
                curBoxBarcode = undefined;
            }
            if (curBoxBarcode !== boxWithMag.box.barcode) { // dump out the box change
                curBoxBarcode = boxWithMag.box.barcode;
                // this is a bit of a hack and slow -- but allows us to include the counts in the header
                retVal.push(buildBoxLocationRow(boxWithMag, parentKey));
            }
        });

        return retVal;
    }
    
    function buildBoxLocationRow(boxWithMags: BTOBoxAndMagsItem, parentKey: string) {
        const box = boxWithMags.box;
        const key = box.barcode+"-"+box.parentOrderId+"-"+parentKey;

        if (boxIsGhostBox(boxWithMags.box)) {
            return dumpBoxAsGhostBox(boxWithMags, key, box.parentOrderId, true);
        }
        if (boxHasBeenPicked(box)) {
            return dumpBoxAsOut(boxWithMags, key, box.parentOrderId, true, false);
        }
        else {
            return dumpBoxAsIn(boxWithMags, key, box.parentOrderId, true, false);
        }
    }
    
    function showBoxesOrderedByOrderNumber() {
        if(!isOrderingByOrderNumber()) { // don't show any of this.
            return;
        }

        if(!boxesByOrderId || boxesByOrderId.length===0) {
            return <tr>
                <td colSpan="4">
                    <i className="fa fa-exclamation-circle li-fg-danger mr-2"/>No boxes found to pick.
                </td>
            </tr>;
        }

        let retVal=[];
        let curOrderId = undefined;
        boxesByOrderId.forEach( (boxInfo:BTOBoxAndMagsItem,index) => {
            if(curOrderId!==boxInfo.box.parentOrderId) { // changing the current order
                curOrderId = boxInfo.box.parentOrderId;
                // this is a bit of a hack and slow -- but allows us to include the counts in the header
                retVal.push(constructOrderBoxesForOrderId(curOrderId));
            }
        });

        return retVal;
    }
    
    function constructOrderBoxesForOrderId(curOrderId) {
        const retVal=[];
        const boxCountsForOrderForTypes = buildBoxCountsForOrder(curOrderId,boxesByOrderId,globalState.magTypes);

        // header
        retVal.push(<tr className=" li-border-dark-top" key={"DEST"+curOrderId}>
            {buildOrderHeaderString(curOrderId,boxCountsForOrderForTypes)}
        </tr>);
        
        // build the box list for this order
        const boxesForOrder = boxesByOrderId?.filter(boxWithMags => boxWithMags.box.parentOrderId === curOrderId) ?? [];
        boxesForOrder.forEach((boxWithMags, index) => {
            const itemKey = `${index}${boxWithMags.box.barcode}`;
            if (boxIsGhostBox(boxWithMags.box)) {
                retVal.push(dumpBoxAsGhostBox(boxWithMags, itemKey, curOrderId, false));
            }
            else {
                if (boxHasBeenPicked(boxWithMags.box)) {
                    retVal.push(dumpBoxAsOut(boxWithMags, itemKey, curOrderId, false, true));
                } else {
                    retVal.push(dumpBoxAsIn(boxWithMags, itemKey, curOrderId, false, true));
                }
            }
        });
        
        return retVal;
    }
    
    function boxHasBeenPicked(box:BTOBox) {
        return box.datePickCompleted !== null;
    }

    function buildBoxCountsForOrder(orderId, boxesByOrderId:BTOBoxAndMagsItem[], magTypes) {
        const boxCountsByType = magTypes.items.map( (magType) => {
            return boxesByOrderId.reduce( (prevVal, boxItem) => {
                if (boxItem.box.holdsMagType === magType.id && boxItem.box.parentOrderId===orderId) {
                    return prevVal + 1;
                }
                return prevVal;
            },0);
        });
        return boxCountsByType;
    }
    
    function dumpTotalBoxCounts() {
        const boxCountsMap = globalState.magTypes.items.map( (magType, index) => {
            const count = rawBoxesAndMagsList?.reduce( (prevVal, boxItem) => {
                    if (boxItem.box.holdsMagType === magType.id) {
                        return prevVal + 1;
                    }
                    return prevVal;
                },0);
            if(count===0) return null; // ignore
            const itemKey = index+magType.id;
            return  <div key={itemKey} className="p-0 m-0">'{magType.description}' Boxes: <strong>{count}</strong></div>
        });
        return (
            <div id="psBoxCountList" className="p-0 m-0 medium text-right">
                {boxCountsMap}
            </div>
        );
    }

    function dumpSelectAll() {
        return(
            <div>
                <input type="checkbox" className="mt-4 ml-2 large align-self-center li-sample-cb" name={"retrieval-cb-all"}
                       aria-label="Checkbox" onChange={(e) => handleSelectAllCBChanged(e)}
                />
                <span className="ml-3">Select All Boxes</span>
            </div>

        );
    }
    
    //#endregion OUTPUT_FUNCTIONS
    
    //#region HELPERS
    
    function getOrderRequestedBy(orderNumber, orders):string {
        const order = orders.find( item => item.id===orderNumber);
        if(order) {
            return order?.requester?.fullName??"-";
        }
        return "-";
    }
    
    function markBoxesAsRemoved(boxIds:[]) {
        const boxesAndMagsListCopy = [...rawBoxesAndMagsList];
        boxIds.forEach(removedBoxId => {
            const s = boxesAndMagsListCopy.find(boxWithMags => boxWithMags.box.id === removedBoxId);
            if (s) {
                s.box.datePickCompleted = Date.now();       // fake it - just something not null
            }
        });
        setCheckedItems({});
        setRawBoxesAndMagsList(boxesAndMagsListCopy); // copy
    }
    
    function checkForPickSheetComplete(boxesAndMagsList:BTOBoxAndMagsItem[]) {
        if(boxesAndMagsList.length===0) {
            return; // ignore
        }
        let notPicked = boxesAndMagsList.filter(boxWithMags => 
                            boxWithMags.box.datePickCompleted === null);
        if (notPicked.length===0) {
            // we are part of the Popup() so we need to use the ErrorPopup here -- hack.
            Popup.showConfirm("Pick Sheet Complete","<p>This Pick Sheet is completely picked.</p><p>Should we mark the associated order(s) as complete?</p>", 
                "Yes, Mark as Complete", ()=>{},() => markParentOrdersAsComplete(), null, null, "No");
        }
    }
    
    async function markParentOrdersAsComplete() {
        setIsLoading(true);
        console.log("marking orders as complete");
        try {
            for (let i = 0; i < gOrders.length; i++) {
                // mark each order as complete
                await ArchiverClientApi.markBTOAsPicked(gOrders[i].id);
            }
            ErrorPopup.showInfo("","Orders Marked as Picked", () =>setRedirectTo("/btos"));
        }
        catch(responseError) {
            return ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError);
        }
        finally {
            setIsLoading(false);
        }
    }

    function markBoxesAsAlreadyOut(boxIds:[]) {
        boxIds.forEach(alreadyOutId => {
            const s = boxesByOrderId.find(boxWithMags => boxWithMags.box.id === alreadyOutId);
            if (s) {
                s.datePickCompleted = 0; // fake it so it stays in the list ### likely won't work right -pott 250609
            }
        });
        setCheckedItems({});
    }
    
    function markBoxesAsNotFound(boxIds:[]) {
        boxIds.forEach(notFoundId => {
            const s = boxesByOrderId.find(boxWithMags => boxWithMags.box.id === notFoundId);
            if (s) {
                s.datePickCompleted = -1; // fake it so it stays in the list ### likely won't work right -pott 250609
            }
        });
        setCheckedItems({});
    }
        
    function doKickOffBoxRelocationAtServer(ids) {
        setIsLoading(true);
        
        ArchiverClientApi.sendPickBoxesRequest(ids)
        .then( ({boxesRemoved, boxesAlreadyOut, boxesNotFound}) => {
            uncheckSelectAll();
            markBoxesAsRemoved(boxesRemoved);
            markBoxesAsAlreadyOut(boxesAlreadyOut);
            markBoxesAsNotFound(boxesNotFound);
            
            const boxesRemovedCount = boxesRemoved?.length;
            const boxesAlreadyOutCount = boxesAlreadyOut?.length;
            const boxesNotFoundCount = boxesNotFound?.length;
            const basicMessage = "<p>Pick Sheet has been updated.</p>";
            const message = boxesRemovedCount>0 ? 
                `<p>${boxesRemovedCount} box${boxesRemovedCount===1?"":"es"} marked as PICKED.</p>`:"";
            const message2 = boxesAlreadyOutCount>0 ? 
                `<p>${boxesAlreadyOutCount} box${boxesAlreadyOutCount===1?"":"es"} already marked as PICKED and could not be picked.</p>`:"";
            const message3 = boxesNotFoundCount>0 ? 
                `<p>${boxesNotFoundCount} box${boxesNotFoundCount===1?"":"es"} not found in the system and could not be picked.</p>`:"";
            ErrorPopup.showInfo("Pick Results", basicMessage+message+message2+message3, null);
        })
        .catch( responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
        .finally( () => {
            setIsLoading(false);
        });
    }
    
    function uncheckSelectAll() {
        const cb = document.getElementsByName("retrieval-cb-all");
        if(cb && cb.length>0) {
            cb[0].checked = false;
        }
    }
    
    function isOrderingByLocation() {
        return orderBy===SORT_ORDER_BOX_LOCATION;
    }

    function isOrderingByOrderNumber() {
        return orderBy===SORT_ORDER_ORDER_NUMBER;
    }
    
    function haveCheckedNonDisabledBoxes(checkedItemsList) {
        const ids = Object.keys(checkedItemsList);
        const nonDisabled = ids?.filter(i => {
            const v = document.getElementsByName("retrieval-cb-" + i);
            if(!v || v.length===0) return true;  // true == keep
            const disabled = v[0].disabled;
            return !disabled;  // keep
        })??[];
        return nonDisabled.length>0;
    }
    
    //#endregion HELPERS
    
    if(redirectTo) {
        return (
            <Redirect push to={redirectTo}/>
        );
    }
    
    return(
        <div className="container li-font-medium">
            <Header title="Box Pick Sheet"/>
            <div className="li-header-row my-4">
                <BackButton/>
                <h1 className="ml-2 d-inline-block align-middle">Box Pick Sheet</h1>
            </div>
            
            <div className="row m-0 p-0 justify-content-between">
                <div>
                    <h3>Date: {LIUtils.dateToShortDateTimeString(pickSheetDate)}</h3>
                    <p className="li-font-small m-0 p-0"><strong>Generated By:</strong> {globalState.clientInfo.fullName}</p>
                </div>
                <div id="pickSheetSortList" className="li-font-med-small">
                    <span>Sort by</span>
                    <span id="psSortByLocation" className={"btn-link li-pointer ml-1 "+(isOrderingByLocation()?"li-text-underline font-weight-bold":"")} onClick={() => setOrderBy(SORT_ORDER_BOX_LOCATION)}>Box Location</span> |
                    <span id="psSortByOrderNumber" className={"btn-link li-pointer ml-1 "+(isOrderingByOrderNumber()?"li-text-underline font-weight-bold":"")} onClick={() => setOrderBy(SORT_ORDER_ORDER_NUMBER)}>Order #</span> |
                </div>
            </div>

            {isLoading &&
                <div className="text-center my-5">
                    Generating Picksheet<LoadingSpinner medium center/>
                </div>
            }
            {!isLoading &&
                <>
                <div className="row m-0 p-0 justify-content-between">
                    {dumpSelectAll()}
                    {dumpTotalBoxCounts()}
                </div>
                {/* SHOW BOXES ORDERED BY... */}
            
                <table className="table li-picksheet-table li-font-med-small my-3 w-100">
                    <tbody>
                        {!isLoading && showBoxesOrderedByLocationAndBox()}
                        {!isLoading && showBoxesOrderedByOrderNumber()}
                    </tbody>
                </table>

                {/* MARK ACTION BUTTONS */}
                <div className="row justify-content-around my-4">
                    <button className="li-button li-primary li-font-medium px-4" disabled={!aBoxIsSelected} 
                            onClick={handlePickBoxes}>
                        Mark Boxes Picked
                    </button>
                    <button className="li-button li-primary li-font-medium px-5" onClick={handlePrintPage}>
                        Print
                    </button>
                </div>
                </>
            }
        </div>
    );
}

export default BTOPickSheetPage;